var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import api from './api'; // Importa a instância configurada do axios
// Função para realizar o login
export var login = function (email, password) { return __awaiter(void 0, void 0, Promise, function () {
    var response, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post("auth/login", { email: email, password: password })];
            case 1:
                response = _a.sent();
                data = response.data;
                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user));
                return [2 /*return*/, data];
            case 2:
                error_1 = _a.sent();
                console.error("Erro no login:", error_1); // Log detalhado do erro
                // Verifica se é um erro do axios para extrair a mensagem do backend, se disponível
                if (axios.isAxiosError(error_1) && error_1.response) {
                    throw new Error(error_1.response.data.detail || "E-mail ou senha incorretos.");
                }
                throw new Error("Erro ao tentar fazer login."); // Mensagem genérica
            case 3: return [2 /*return*/];
        }
    });
}); };
// Função para obter o token do localStorage
export var getToken = function () {
    return localStorage.getItem("token");
};
// Função para realizar o logout (opcional, mas útil)
export var logout = function (afterLogout) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // Chama callback para atualizar contexto, se fornecido
    if (afterLogout)
        afterLogout();
    // console.log("Token removido do localStorage.");
};
// Função para registrar um novo usuário
export function register(email, password, whatsapp_number, utmData) {
    return __awaiter(this, void 0, void 0, function () {
        var response, data, error_2, data, messages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.post("auth/register", {
                            email: email,
                            password: password,
                            whatsapp_number: whatsapp_number,
                            utm_data: utmData // ✅ Envia UTM para o backend
                        })];
                case 1:
                    response = _a.sent();
                    data = response.data;
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("user", JSON.stringify(data.user));
                    return [2 /*return*/, data];
                case 2:
                    error_2 = _a.sent();
                    if (axios.isAxiosError(error_2) && error_2.response) {
                        data = error_2.response.data;
                        // Exibe qualquer mensagem de erro do campo email
                        if (data.email && Array.isArray(data.email) && data.email[0]) {
                            throw new Error(data.email[0]);
                        }
                        // Mostra todos os campos de erro, se existirem
                        if (typeof data === 'object') {
                            messages = Object.values(data).flat().join(' ');
                            throw new Error(messages || data.detail || "Erro ao registrar usuário.");
                        }
                        throw new Error(data.detail || "Erro ao registrar usuário.");
                    }
                    throw new Error("Erro ao registrar usuário.");
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Função para solicitar recuperação de senha
export function forgotPassword(email) {
    return __awaiter(this, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.post("auth/password-reset/", { email: email })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    error_3 = _a.sent();
                    throw new Error("Erro ao solicitar recuperação de senha.");
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Função para redefinir a senha usando o token
export function resetPassword(token, password) {
    return __awaiter(this, void 0, void 0, function () {
        var error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.post("auth/reset-password/", { token: token, password: password })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    error_4 = _a.sent();
                    if (axios.isAxiosError(error_4) && error_4.response) {
                        throw new Error(error_4.response.data.detail ||
                            "Erro ao redefinir a senha. O link pode estar expirado ou inválido.");
                    }
                    throw new Error("Erro ao redefinir a senha.");
                case 3: return [2 /*return*/];
            }
        });
    });
}
